import { useCurrentTime } from "@poscon/shared-frontend";
import React from "react";

export const TimeContext = React.createContext<{
  now: Date;
} | null>(null);

export const TimeContextProvider = ({
  children,
  delay = 1000,
}: {
  children: React.ReactNode;
  delay?: number;
}) => {
  const now = useCurrentTime(delay);
  return (
    <TimeContext.Provider value={{ now }}>
      {children}
    </TimeContext.Provider>
  );
};

export const useTimeContext = () => {
  const context = React.useContext(TimeContext);
  if (!context) {
    throw new Error("useTimeContext must be used within a TimeContextProvider");
  }
  return context.now;
};